module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAJ1JREFUOE/Fk7ENwjAUBe9NQEUBA0DLBrAWCwCZihXYAIkFKOhoHiSKUTD+BCmKcPOrO92XbTHwaCDPuALbS+Au6RyVhgW2F8CxFjznWtKlJCkKOvC8heqCTUnyIejAM2ALTNpZlLwJclhSVRfY3kWSlyCC096RpBH0wd8ksj0FTkCzc8qOri0rWaWCA3Dtg7OSm6T9uC/xl3/y/4IH/qpNHLAALycAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/up-arrow-icon.png
// module id = oqS/
// module chunks = 12